import React from 'react';
import '../pages/DuelPage.css';
const ZoneViewerModal = ({ cards, title, onClose, onCardClick, onDetach  }) => {
  
  return (
    <div className="deck-modal-backdrop">
      <div className="deck-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title} ({cards.length} cards)</h3>
        <div className="deck-gallery">
          {cards.map((card, index) => (
          <div
            key={`viewer-card-${card.id}-${index}`} // Use card ID + index for truly unique React keys
            // This prevents duplicate key warnings when viewing decks with duplicate cards
            className="viewer-card-wrapper"
          >
            <img
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable={false}
              src={card.card_images[0].image_url}
              alt={card.name}
              className="deck-gallery-card"
              onClick={() => onCardClick && onCardClick(card)}
              style={{ cursor: onCardClick ? 'pointer' : 'default' }}
            />
            {card.isFaceDown && <div className="face-down-label">FD</div>}

            {title === 'XYZ Materials' && onDetach && (
              <button
                className="detach-button"
                onClick={() => onDetach(index)}
              >
                Detach
              </button>
            )}
          </div>
        ))}


        </div>


        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default ZoneViewerModal;